import * as UAParser from "ua-parser-js";

export class Context {
    protected uaParser: UAParser;
    protected device;
    protected browser;

    constructor() {
        this.uaParser = new UAParser(navigator.userAgent);
        this.device = this.uaParser.getDevice();
        this.browser = this.uaParser.getBrowser();
    }

    public isMobile()
    {
        return this.device.type == 'mobile';
    }

}